import React, { useEffect, useState } from "react";
import { useAdminAuth } from "../../context/AdminAuthContext";
import ApprovalModal from "../../components/ApprovalModal"; // Import Modal

const Approvals = () => {
  const { token } = useAdminAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Modal State
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const fetchPending = async () => {
    try {
      const res = await fetch("https://luxuriyahomes.com/api/admin/team/pending", {
        headers: { Authorization: `Bearer ${token}` }
      });
      if(res.ok) setUsers(await res.json());
    } catch(err) { console.error(err); } 
    finally { setLoading(false); }
  };

  useEffect(() => { fetchPending(); }, []);

  return (
    <div className="text-white">
      <h2 className="text-2xl font-light mb-6">Pending Approvals</h2>
      
      {loading ? <p>Loading...</p> : (
        <div className="bg-[#1c1c1c] rounded-xl border border-zinc-800 overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-zinc-900 text-xs uppercase text-zinc-500">
              <tr>
                <th className="p-4">Name</th>
                <th className="p-4">Email</th>
                <th className="p-4 text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800">
              {users.length === 0 ? (
                <tr><td colSpan={3} className="p-6 text-center text-zinc-500">No pending requests.</td></tr>
              ) : (
                users.map((user: any) => (
                  <tr key={user.id} className="hover:bg-zinc-800/30">
                    <td className="p-4">{user.name}</td>
                    <td className="p-4 text-zinc-400">{user.email}</td>
                    <td className="p-4 text-right">
                      {/* Open Modal Button */}
                      <button 
                        onClick={() => setSelectedUser(user)}
                        className="bg-amber-600 text-black px-4 py-2 rounded hover:bg-amber-500 text-xs font-bold uppercase tracking-wider"
                      >
                        Review & Approve
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* RENDER MODAL IF USER SELECTED */}
      {selectedUser && (
        <ApprovalModal 
            user={selectedUser} 
            onClose={() => setSelectedUser(null)} 
            onSuccess={fetchPending} // List refresh after approval
        />
      )}

    </div>
  );
};

export default Approvals;